import { omit, find } from 'lodash'
import moment from 'moment'

export function makeFields(data) {
  const excludeEditData = [
    'id',
    'school_id',
    'contact_id',
    'contact',
    'enrollment',
    'medical_history',
    'photo',
    'siblings',
    // Siblings
    'has_sibling',
    'student_elective_subjects',
    'student_parents',
    'created_at',
    'updated_at',
    'deleted_at',
  ]
  const editData = omit(data, excludeEditData)
  editData.dob = moment(editData.dob)
  editData.admission_date = moment(editData.admission_date)
  // Build Student Contact
  const contact = data.contact
  const contactData = {
    'student[contact][address]': contact.address,
    'student[contact][city]': contact.city,
    'student[contact][district]': contact.district,
    'student[contact][landmark]': contact.landmark,
    'student[contact][pincode]': contact.pincode,
    'student[contact][state]': contact.state,
    'student[contact][country]': contact.country,
    // 'contact[is_primary]': contact.is_primary,
    'student[contact][country_code]': contact.country_code,
    'student[contact][phone]': contact.phone,
    'student[contact][alt_country_code]': contact.alt_country_code,
    'student[contact][alt_phone]': contact.alt_phone,
    'student[contact][email]': contact.email,
  }

  // Build Father's Data
  const father = find(data.student_parents, ['relation', 'father'])
  const fatherData = {
    'father[suffix]': father.suffix || undefined,
    'father[first_name]': father.first_name,
    'father[last_name]': father.last_name,
    'father[id_type]': father.id_type,
    'father[id_number]': father.id_number,
    'father[income]': father.income,
    'father[occupation]': father.occupation,
    'father[office_address]': father.office_address,
    'father[qualification]': father.qualification,

    'father[contact][address]': father.contact.address,
    'father[contact][city]': father.contact.city,
    'father[contact][district]': father.contact.district,
    'father[contact][landmark]': father.contact.landmark,
    'father[contact][pincode]': father.contact.pincode,
    'father[contact][state]': father.contact.state,
    'father[contact][country]': father.contact.country,
    // 'contact[is_primary]': contact.is_primary,
    'father[contact][country_code]': father.contact.country_code,
    'father[contact][phone]': father.contact.phone,
    'father[contact][alt_country_code]': father.contact.alt_country_code,
    'father[contact][alt_phone]': father.contact.alt_phone,
    'father[contact][email]': father.contact.email,
  }

  // Build Mother's Data
  let motherData = {}
  const mother = find(data.student_parents, ['relation', 'mother'])
  if (mother) {
    motherData = {
      'mother[suffix]': mother.suffix || undefined,
      'mother[first_name]': mother.first_name,
      'mother[last_name]': mother.last_name,
      'mother[id_type]': mother.id_type,
      'mother[id_number]': mother.id_number,
      'mother[income]': mother.income,
      'mother[occupation]': mother.occupation,
      'mother[office_address]': mother.office_address,
      'mother[qualification]': mother.qualification,

      'mother[contact][address]': mother.contact.address,
      'mother[contact][city]': mother.contact.city,
      'mother[contact][district]': mother.contact.district,
      'mother[contact][landmark]': mother.contact.landmark,
      'mother[contact][pincode]': mother.contact.pincode,
      'mother[contact][state]': mother.contact.state,
      'mother[contact][country]': mother.contact.country,
      // 'contact[is_primary]': contact.is_primary,
      'mother[contact][country_code]': mother.contact.country_code,
      'mother[contact][phone]': mother.contact.phone,
      'mother[contact][alt_country_code]': mother.contact.alt_country_code,
      'mother[contact][alt_phone]': mother.contact.alt_phone,
      'mother[contact][email]': mother.contact.email,
    }
  }

  // Build Guardian's Data
  let guardianData = {}
  const guardian = find(data.student_parents, ['relation', 'guardian'])
  if (guardian) {
    guardianData = {
      'guardian[suffix]': guardian.suffix || undefined,
      'guardian[first_name]': guardian.first_name,
      'guardian[last_name]': guardian.last_name,
      'guardian[id_type]': guardian.id_type,
      'guardian[id_number]': guardian.id_number,
      'guardian[income]': guardian.income,
      'guardian[occupation]': guardian.occupation,
      'guardian[office_address]': guardian.office_address,
      'guardian[qualification]': guardian.qualification,
      'guardian[gender]': guardian.gender,
      'guardian[guardian_relation]': guardian.guardian_relation,

      'guardian[contact][address]': guardian.contact.address,
      'guardian[contact][city]': guardian.contact.city,
      'guardian[contact][district]': guardian.contact.district,
      'guardian[contact][landmark]': guardian.contact.landmark,
      'guardian[contact][pincode]': guardian.contact.pincode,
      'guardian[contact][state]': guardian.contact.state,
      'guardian[contact][country]': guardian.contact.country,
      // 'contact[is_primary]': contact.is_primary,
      'guardian[contact][country_code]': guardian.contact.country_code,
      'guardian[contact][phone]': guardian.contact.phone,
      'guardian[contact][alt_country_code]': guardian.contact.alt_country_code,
      'guardian[contact][alt_phone]': guardian.contact.alt_phone,
      'guardian[contact][email]': guardian.contact.email,
    }
  }
  // Build Enrollment Data
  const enrollment = data.enrollment
  const enrollmentData = {
    'enrollment[class_id]': enrollment.class_id,
    'enrollment[section_id]': enrollment.section_id,
    session_id: enrollment.session_id,
    'enrollment[roll_no]': enrollment.roll_no,
    'enrollment[house_id]': enrollment.house_id,
  }

  const meta = data.student_meta || {}
  const metaData = {
    'student[meta][board_10th_reg_no]': meta.board_10th_reg_no || '',
    'student[meta][aay]': Number(meta.aay) || 0,
    'student[meta][cwsn]': Number(meta.cwsn) || 0,
    'student[meta][cwsn_facility]': meta.cwsn_facility || '',
    'student[meta][competition_appeared]': Number(meta.competition_appeared) || 0,
    'student[meta][competition_type]': meta.competition_type || '',
    'student[meta][sld]': Number(meta.sld) || 0,
    'student[meta][sld_facility]': meta.sld_facility || '',
    'student[meta][ews]': Number(meta.ews) || 0,
    'student[meta][asd]': Number(meta.asd) || 0,
    'student[meta][adhd]': Number(meta.adhd) || 0,
    'student[meta][gifted]': Number(meta.gifted) || 0,
    'student[meta][sports]': Number(meta.sports) || 0,
    'student[meta][orphaned]': Number(meta.orphaned) || 0,
    'student[meta][idp]': Number(meta.idp) || 0,
    'student[meta][tattooed]': Number(meta.tattooed) || 0,
  }
  // const studentMetaData = {
  //   'sic': data.sic || 'neet',
  //   'hostel': data.hostel || '0',
  //   'hostel_name': data.hostel_name || '',
  //   'transport': data.transport || 0,
  //   'transport_pickup_point': data.transport_pickup_point || '',
  // }

  // Build Elective Subjects Data
  const electiveSubjects = data.student_elective_subjects
  const electiveSubjectData = {}

  const groupedElectives = electiveSubjects.reduce((acc, subject) => {
    const electiveId = subject.pivot.elective_subject_id
    const subjectId = subject.pivot.subject_id

    let elective = acc.find((e) => e.elective_subject_id === electiveId)

    if (!elective) {
      elective = { elective_subject_id: electiveId, subject_ids: [] }
      acc.push(elective)
    }

    elective.subject_ids.push(subjectId)
    return acc
  }, [])

  console.log('electiveSubjects', electiveSubjects)
  console.log('groupedElectives', groupedElectives)

  groupedElectives.forEach(function (item) {
    electiveSubjectData[`elective_subject[${item.elective_subject_id}][subject_id]`] = item.subject_ids
  })
  // selectiveSubjectData[`elective_subject[${item.pivot.elective_subject_id}][subject_id]`] = electiveSubjectIds
  return {
    ...contactData,
    ...editData,
    ...fatherData,
    ...motherData,
    ...guardianData,
    ...enrollmentData,
    ...electiveSubjectData,
    ...metaData,
    // ...studentMetaData,
  }
}
